import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import ReplyingToMessage from 'srcReact/MessengerPage/components/ReplyingToMessage'
import { messengerActions } from 'srcReact/MessengerPage'
import Content from './components/Content'
import Popup from 'reactjs-popup'
import MessageActions from './components/MessageActions'
import { convertToPlain } from 'srcReact/helpers/utils'

export default function ViewMessage({
  messageProp,
  user,
  appendToPrevious,
  isLastMessage,
  isFirstMessage,
  lastMessageRef,
  firstMessageRef,
  setEditMode,
  isMessageAppended,
  deleteMessagePopin,
  showImageModal,
  setEmojiPickerForMessage,
  unsetEmojiPickerForMessage,
  isEmojiPickerOpen,
  showTime,
  messageTime,
  isMobile,
  isSender,
  showUserModal,
  selectedMessage,
  setSelectedMessage,
  isFileProcessing,
  targetRefs,
  scrollToTarget,
  fromQuickMessenger
}) {
  const { id, createdAt, message, origin_message, origin_message_id, files, reactions, has_been_deleted } = messageProp
  const dispatch = useDispatch()
  const [isMessageOptionsVisible, setIsMessageOptionsVisible] = useState(false)

  const {
    login: { user: loggedInUser },
    messenger: { openedConversation, reactionProcessing, reactionToProcess }
  } = useSelector((state) => state)

  const copyMessage = () => {
    if (messageProp.message) {
      const tempInput = document.createElement('textarea')
      tempInput.value = convertToPlain(messageProp.message)
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
    }
    setIsMessageOptionsVisible(false)
  }

  const replyMessage = () => {
    dispatch(messengerActions.setOriginMessage({ message: messageProp, user }))
    setIsMessageOptionsVisible(false)
  }

  const editMessage = () => {
    setEditMode(messageProp)
    setIsMessageOptionsVisible(false)
  }

  const appendEmoji = (emojiObject) => {
    setIsMessageOptionsVisible(false)
    let alreadyAddedReaction = null
    if (reactions && reactions.length > 0) {
      const filteredReaction = reactions.find((r) => r.unified_unicode === emojiObject.unified)
      if (filteredReaction) {
        alreadyAddedReaction = filteredReaction.users.find((u) => u.id_user === loggedInUser.id)
      }
    }
    if (alreadyAddedReaction) {
      dispatch(messengerActions.deleteReactionFromMessage(alreadyAddedReaction.id))
    } else {
      dispatch(messengerActions.addReactionToMessage(id, emojiObject.unified))
    }
  }

  const handleOpenPicker = (isOpen) => {
    if (isOpen) {
      setEmojiPickerForMessage(messageProp)
    } else {
      unsetEmojiPickerForMessage()
    }
  }

  const handleReactionClick = (reaction, hasLoggedInUserReacted) => {
    if (hasLoggedInUserReacted) {
      const reactionId = reaction.users.find((u) => u.id_user === loggedInUser.id).id
      dispatch(messengerActions.deleteReactionFromMessage(reactionId, reaction.unified_unicode, id))
    } else {
      dispatch(messengerActions.addReactionToMessage(id, reaction.unified_unicode))
    }
  }

  const showMessageOptions = () => {
    if (!isMobile) {
      setIsMessageOptionsVisible(true)
    }
  }

  const hideMessageOptions = () => {
    if (!isMobile) {
      setIsMessageOptionsVisible(false)
    }
  }

  const showMobileMessageOptions = () => {
    // if (isMobile) {
    setIsMessageOptionsVisible(true)
    // }
  }

  const hideMobileMessageOptions = () => {
    // if (isMobile) {
    setIsMessageOptionsVisible(false)
    // }
  }

  const toggleMessageOptions = (message) => {
    if (setSelectedMessage) {
      if (selectedMessage?.id === message.id) {
        setSelectedMessage(null)
        hideMobileMessageOptions()
      } else {
        setSelectedMessage(message)
        showMobileMessageOptions()
      }
    }
  }

  const isInvalidConversation = () => {
    if (openedConversation) {
      const isOne2OneConv = openedConversation.active_users.length === 2
      if (isOne2OneConv) {
        const inValidUser = openedConversation.active_users.find((user) => user.status !== 'active')
        if (inValidUser && inValidUser.id > 0) {
          return true
        }
      }
    }
    return false
  }
  const isActiveConvoUser = openedConversation
    ? openedConversation.conversation.isLeftByUser === 0 && openedConversation.conversation.hasBeenRemoved === 0
    : false

  return (
    <div
      // onMouseEnter={showMessageOptions}
      // onMouseLeave={hideMessageOptions}
      className={`${styles.outerMessageContainer} ${isFirstMessage && styles.outerMessageContainerLastMessage} ${
        !appendToPrevious && styles.outerMessageContainerNonAppended
      } ${origin_message && isMessageAppended && has_been_deleted !== 1 && styles.replyingOuterMessageContainer}`}
      ref={isFirstMessage ? firstMessageRef : isLastMessage ? lastMessageRef : null}>
      {origin_message && isMessageAppended && has_been_deleted !== 1 && (
        <ReplyingToMessage
          messageObj={{ message: { id: origin_message_id, message: origin_message } }}
          messageContainerCSS={styles.replyingViewMessageContainer}
          originMessageContainerCSS={styles.origiViewMessageContainerCSS}
          targetRefs={targetRefs}
          scrollToTarget={scrollToTarget}
        />
      )}
      <div
        className={`${styles.options} ${appendToPrevious && styles.appendedOptions} ${
          messageProp.has_been_deleted === 1 && styles.optionsDeletedMessage
        }`}>
        <button
          type='button'
          onClick={() => toggleMessageOptions(messageProp)}
          className={`${styles.buttonMessageContainer} ${
            messageProp.has_been_deleted === 1 && styles.buttonDeletedMessageContainer
          }`}>
          <Content
            isMessageOptionsVisible={isMessageOptionsVisible && selectedMessage?.id === messageProp.id}
            messageProp={messageProp}
            showImageModal={showImageModal}
            showTime={showTime}
            messageTime={messageTime}
            isMessageAppended={isMessageAppended}
            appendEmoji={appendEmoji}
            handleReactionClick={handleReactionClick}
            handleOpenPicker={handleOpenPicker}
            appendToPrevious={appendToPrevious}
            reactionProcessing={reactionProcessing}
            reactionToProcess={reactionToProcess}
            showUserModal={showUserModal}
            activeUsers={openedConversation && openedConversation.active_users}
            isSender={isSender}
            isFileProcessing={isFileProcessing}
            targetRefs={targetRefs}
            scrollToTarget={scrollToTarget}
            fromQuickMessenger={fromQuickMessenger}
          />
        </button>
        {isMessageOptionsVisible &&
          selectedMessage?.id === messageProp.id &&
          isActiveConvoUser &&
          messageProp.has_been_deleted !== 1 &&
          !isInvalidConversation() && (
            <MessageActions
              isActiveConvoUser={isActiveConvoUser}
              isLoggedInUser={messageProp.id_user === loggedInUser.id}
              editMessage={() => editMessage()}
              deleteMessagePopin={() => {
                deleteMessagePopin(messageProp)
                setIsMessageOptionsVisible(false)
              }}
              replyMessage={replyMessage}
              copyMessage={copyMessage}
              appendEmoji={appendEmoji}
              handleOpenPicker={handleOpenPicker}
              isEmojiPickerOpen={isEmojiPickerOpen}
            />
          )}
      </div>
    </div>
  )
}
